module.exports = __webpack_public_path__ + "static/media/phone.58b5d0bb.svg";